// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Avatar_avatar__v3NRi {
  border-radius: 100%;
  display: inline-flex;
  justify-content: center;
  align-items: center;
}
.Avatar_avatarCompany__rzOHt {
  border-radius: 16%;
}

.Avatar_image__y1mm5 {
  border-radius: 100%;
  width: 100%;
  height: 100%;
}
.Avatar_image__company__-H6i1 {
  border-radius: 16% !important;
  border: 1px solid #E5E6EE;
}

.Avatar_profilePlaceholder__k6fkC {
  width: 100%;
  height: 100%;
  border-radius: 100%;
  text-transform: uppercase;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  pointer-events: none;
}

.Avatar_companyPlaceholder__\\+1q2t {
  width: 100%;
  height: 100%;
  border-radius: 16%;
  border: 1px solid #E5E6EE;
  text-transform: uppercase;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  -webkit-user-select: none;
     -moz-user-select: none;
          user-select: none;
  pointer-events: none;
  background: #EBECF2;
}
.Avatar_companyPlaceholder__img__Iyw2K {
  width: 100%;
  height: auto;
  max-width: 50px;
}

.Avatar_online__wZqDX {
  position: relative;
}
.Avatar_online__wZqDX:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 8px;
  height: 8px;
  border: 1px solid white;
  background: #3EBF71;
  border-radius: 100%;
}

.Avatar_onlineRecently__KEMoE {
  position: relative;
}
.Avatar_onlineRecently__KEMoE:after {
  content: "";
  position: absolute;
  bottom: 0;
  right: 0;
  width: 8px;
  height: 8px;
  border: 1px solid white;
  background: #E59F42;
  border-radius: 100%;
}

@keyframes Avatar_image-appear__TreZf {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}`, "",{"version":3,"sources":["webpack://./../../packages/sdk/src/components/ui/Avatar/Avatar.module.scss"],"names":[],"mappings":"AAEA;EACE,mBAAA;EACA,oBAAA;EACA,uBAAA;EACA,mBAAA;AADF;AAGE;EACE,kBAToB;AAQxB;;AAKA;EACE,mBAAA;EACA,WAAA;EACA,YAAA;AAFF;AAME;EACE,6BAAA;EACA,yBAAA;AAJJ;;AAQA;EACE,WAAA;EACA,YAAA;EACA,mBAAA;EAEA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,oBAAA;AANF;;AAYA;EACE,WAAA;EACA,YAAA;EACA,kBA9CsB;EA+CtB,yBAAA;EACA,yBAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,yBAAA;KAAA,sBAAA;UAAA,iBAAA;EACA,oBAAA;EAEA,mBAAA;AAVF;AAYE;EACE,WAAA;EACA,YAAA;EACA,eAAA;AAVJ;;AAcA;EACE,kBAAA;AAXF;AAaE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAXJ;;AAeA;EACE,kBAAA;AAZF;AAcE;EACE,WAAA;EACA,kBAAA;EACA,SAAA;EACA,QAAA;EACA,UAAA;EACA,WAAA;EACA,uBAAA;EACA,mBAAA;EACA,mBAAA;AAZJ;;AAiBA;EACE;IACE,UAAA;EAdF;EAgBA;IACE,UAAA;EAdF;AACF","sourcesContent":["$company-border-radius: 16%;\n\n.avatar {\n  border-radius: 100%;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n\n  &Company {\n    border-radius: $company-border-radius;\n  }\n}\n\n.image {\n  border-radius: 100%;\n  width: 100%;\n  height: 100%;\n\n  //animation: 0.15s image-appear;\n\n  &__company {\n    border-radius: #{$company-border-radius} !important;\n    border: 1px solid #E5E6EE;\n  }\n}\n\n.profilePlaceholder {\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n\n  text-transform: uppercase;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  pointer-events: none;\n  //opacity: 0;\n\n  //animation: 0.1s 0.3s image-appear forwards;\n}\n\n.companyPlaceholder {\n  width: 100%;\n  height: 100%;\n  border-radius: $company-border-radius;\n  border: 1px solid #E5E6EE;\n  text-transform: uppercase;\n  color: white;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  user-select: none;\n  pointer-events: none;\n  //opacity: 0;\n  background: #EBECF2;\n  //animation: 0.1s 0.3s image-appear forwards;\n  &__img {\n    width: 100%;\n    height: auto;\n    max-width: 50px;\n  }\n}\n\n.online {\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 8px;\n    height: 8px;\n    border: 1px solid white;\n    background: #3EBF71;\n    border-radius: 100%;\n  }\n}\n\n.onlineRecently {\n  position: relative;\n\n  &:after {\n    content: '';\n    position: absolute;\n    bottom: 0;\n    right: 0;\n    width: 8px;\n    height: 8px;\n    border: 1px solid white;\n    background: #E59F42;\n    border-radius: 100%;\n  }\n}\n\n\n@keyframes image-appear {\n  from {\n    opacity: 0;\n  }\n  to {\n    opacity: 1;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"avatar": `Avatar_avatar__v3NRi`,
	"avatarCompany": `Avatar_avatarCompany__rzOHt`,
	"image": `Avatar_image__y1mm5`,
	"image__company": `Avatar_image__company__-H6i1`,
	"profilePlaceholder": `Avatar_profilePlaceholder__k6fkC`,
	"companyPlaceholder": `Avatar_companyPlaceholder__+1q2t`,
	"companyPlaceholder__img": `Avatar_companyPlaceholder__img__Iyw2K`,
	"online": `Avatar_online__wZqDX`,
	"onlineRecently": `Avatar_onlineRecently__KEMoE`,
	"image-appear": `Avatar_image-appear__TreZf`
};
export default ___CSS_LOADER_EXPORT___;
